import AppleIdentityProvider from './providers/AppleIdentityProvider';
import FacebookIdentityProvider from './providers/FacebookIdentityProvider';
import GoogleIdentityProvider from './providers/GoogleIdentityProvider';
import LineIdentityProvider from './providers/LineIdentityProvider';

/**
 * Represents IdentityProvidersFactory
 */
class IdentityProvidersFactory {

	/**
	 * Returns the specific provider instance
	 * @param {string} providerName - identity provider name
	 * @param {object} config - site preference
	 * @returns {IdentityProvider|null} specific provider instance
	 */
	async create(providerName: string, config) {
		switch (providerName) {
			case 'Facebook':
				FacebookIdentityProvider.initConfig(config);
				await FacebookIdentityProvider.initScript('facebook-jssdk', 'https://connect.facebook.net/en_US/sdk.js');
				await FacebookIdentityProvider.initSdk();

				return FacebookIdentityProvider;
			case 'Google':
				GoogleIdentityProvider.initConfig(config);
				await GoogleIdentityProvider.initScript('google-jssdk', 'https://accounts.google.com/gsi/client');

				return GoogleIdentityProvider;
			case 'Apple':
				AppleIdentityProvider.initConfig(config);
			 	await AppleIdentityProvider.initScript('apple-jssdk', 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js');

				return AppleIdentityProvider;
			case 'Line':
				LineIdentityProvider.initConfig(config);

				return LineIdentityProvider;
			default:
				return null;
		}
	}
}

export default new IdentityProvidersFactory();
